var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "link-node-warp"
  }, [_c('h4', [_vm._v("프로토콜 기본정보")]), _c('div', {
    staticClass: "link-item"
  }, [_c('button', {
    staticClass: "EQUIPMENT",
    class: _vm.nodeLinkData['EQUIPMENT'].active === false ? 'disabled' : '',
    attrs: {
      "data-items": _vm.nodeLinkData['EQUIPMENT'].text
    },
    on: {
      "dblclick": function ($event) {
        return _vm.tagPopOn('EQUIPMENT');
      }
    }
  }, [_c('span', [_vm._v("장비")]), _c('b', [_vm._v(_vm._s(_vm.nodeLinkData['EQUIPMENT'].text))])])]), _c('TagOptionPopTagList')], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }